<!--Event info cards to go in events_carousel.-->

<template>
  <mdb-card style="height: 500px;" class="scrollbar scrollbar-primary">
    <mdb-card-image
      class="d-md-none d-lg-block"
      :src="`${block.value.card_with_image.image.image.src}`"
      alt="Event Image"
    ></mdb-card-image>
    <mdb-card-image
      class="d-md-block d-none d-lg-none"
      :src="`${block.value.card_with_image.image.med_image.src}`"
    ></mdb-card-image>
    <mdb-card-body>
      <mdb-card-title>{{block.value.card_with_image.card_title}}</mdb-card-title>
      <mdb-card-text>{{block.value.card_with_image.card_text}}</mdb-card-text>
      <p v-if="block.value.date != null">Date: {{ dateToString }}</p>

      <!--If links are provided, show them on the card. -->

      <ul class="list-unstyled">
        <li
          class="text-left"
          v-for="link in block.value.card_with_image.links"
          :key="link.id"
          >

          <!--If type is not document, then a non-null page or URL will be chosen (in that order)-->

          <p v-if="link.type == 'category_name'" class="official-skin default-color mt-2 text-center"><strong>{{link.value}}</strong></p>
          <router-link
            v-else-if="link.value.document != null"
            :to="`/departmentdocument/${link.value.document.slug}`"
            class="ml-4"
            ><mdb-icon icon="file" class="mr-2"></mdb-icon>{{link.value.title}}
          </router-link>
          <router-link
            v-else-if="link.value.page != null"
            :to="`/${link.value.page.link_page}/${link.value.page.slug}`"
            class="ml-4"
            ><mdb-icon icon="link" class="mr-2"></mdb-icon>{{link.value.title}}
          </router-link>
          <a
            v-else-if="link.value.url != ''"
            :href="link.value.url"
            target="_blank"
            class="ml-4"
            ><mdb-icon icon="link" class="mr-2"></mdb-icon>{{link.value.title}}
          </a>
        </li>
      </ul>
    </mdb-card-body>

    <!--If a button has been requested, show one.-->
    
    <router-link
      v-if="block.value.card_with_image.button.link_page && block.value.card_with_image.button.link_page.link_page"
      class="pb-4"
      :to="`/${block.value.card_with_image.button.link_page.link_page}/${block.value.card_with_image.button.link_page.slug}`"
    >
      <mdb-btn color="primary" size="md">{{block.value.card_with_image.button.link_name}}</mdb-btn>
    </router-link>
  </mdb-card>
</template>

<script>
import {
  mdbCard,
  mdbCardImage,
  mdbCardBody,
  mdbCardTitle,
  mdbCardText,
  mdbBtn,
  mdbIcon
} from "mdbvue";
import shared from "@/shared";
export default {
  name: "information_block",
  props: {
    block: Object
  },
  components: {
    mdbCard,
    mdbCardImage,
    mdbCardBody,
    mdbCardTitle,
    mdbCardText,
    mdbBtn,
    mdbIcon
  },
  computed: {
    dateToString: function() {
      var date = shared.getDate(this.block.value.date);
      return date.toLocaleDateString();
    }
  }
};
</script>